import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
      <Card className="quote-card-view">
        <Card.Body>
          <blockquote className="blockquote mb-0">
            <p style={{ textAlign: "justify" }}>
              Hi everyone! I’m <span className="purple">Yicheng Zou</span>.
              <br />
              I am currently pursuing a{" "}
              <span className="purple">Master of Science in Business Analytics</span>{" "}
              at <span className="purple">Boston University</span>, with an
              academic background in{" "}
              <span className="purple">Economics</span> from{" "}
              <span className="purple">Simon Fraser University</span>.
              <br />
              <br />
              My experience spans{" "}
              <span className="purple">market research</span>,{" "}
              <span className="purple">strategy and operations</span>,{" "}
              <span className="purple">data analysis</span>, and{" "}
              <span className="purple">quantitative decision-making</span>.
              I previously worked as a Research Intern at{" "}
              <span className="purple">Guolian Securities</span> and in{" "}
              <span className="purple">Strategy & Operations</span> at{" "}
              <span className="purple">Monitor Deloitte</span>.
              <br />
              <br />
              I am currently strengthening my technical foundation in software
              development and data analytics, with interests in building practical
              applications that connect technology with real-world business needs.
            </p>

            <ul>
              <li className="about-activity">
                <ImPointRight /> Software Engineering
              </li>
              <li className="about-activity">
                <ImPointRight /> Data Analytics & Business Intelligence
              </li>
              <li className="about-activity">
                <ImPointRight /> Strategy, Operations, and Problem Solving
              </li>
            </ul>

            <p style={{ color: "rgb(155 126 172)" }}>
              "Turning data and technology into practical business solutions."
            </p>
            <footer className="blockquote-footer">Yicheng Zou</footer>
          </blockquote>
        </Card.Body>
      </Card>
  );
}

export default AboutCard;